export const teadsScripts = {
  tr: {
    desktop: {
      Gündem: '//a.teads.tv/page/118554/tag',
      Spor: '//a.teads.tv/page/118553/tag',
      Test: '//a.teads.tv/page/118551/tag',
      Video: '//a.teads.tv/page/118550/tag',
      Yemek: '//a.teads.tv/page/118548/tag',
      Yaşam: '//a.teads.tv/page/118547/tag',
      Seyahat: '//a.teads.tv/page/118546/tag',
      Sağlık: '//a.teads.tv/page/118542/tag',
      Vitrin: '//a.teads.tv/page/118541/tag',
      Ekonomi: '//a.teads.tv/page/166827/tag',
      Finans: '//a.teads.tv/page/166828/tag',
      'Dizi & Film': '//a.teads.tv/page/166829/tag',
      TV: '//a.teads.tv/page/166830/tag',
      Goygoy: '//a.teads.tv/page/118549/tag',
      Magazin: '//a.teads.tv/page/166831/tag',
      Gaming: '//a.teads.tv/page/118543/tag',
      Teknoloji: '//a.teads.tv/page/166832/tag',
      Eğitim: '//a.teads.tv/page/166833/tag',
      'Genel Kültür': '//a.teads.tv/page/166834/tag',
      Güzellik: '//a.teads.tv/page/166835/tag',
      Astroloji: '//a.teads.tv/page/166836/tag',
      'Anne Bebek': '//a.teads.tv/page/166837/tag',
      ROS: '//a.teads.tv/page/118539/tag',
    },
    mobile: {
      Spor: '//a.teads.tv/page/118553/tag',
      Goygoy: '//a.teads.tv/page/118549/tag',
      Gaming: '//a.teads.tv/page/118543/tag',
    },
  },
  en: {
    desktop: {
      ROS: '//a.teads.tv/page/118536/tag',
    },
    mobile: {
      ROS: '//a.teads.tv/page/118536/tag',
    },
  },
  ru: {
    desktop: {
      ROS: '//a.teads.tv/page/90007/tag',
    },
    mobile: {
      ROS: '//a.teads.tv/page/90007/tag',
    },
  },
};
